export const PROCESSING_COUPONS = "PROCESSING_COUPONS";
export const GET_COUPONS_DATA = "GET_COUPONS_DATA";
export const CREATE_COUPON = "CREATE_COUPON";
export const DELETE_COUPON = "DELETE_COUPON";
